import { createRoot } from 'react-dom/client';

class CustomAudioPlayBtnRenderer {
  element: any;
  root: any;

  constructor(props: any) {
    this.element = document.createElement('div');
    this.element.role = 'button';
    this.element.className = 'play-btn';
    this.element.style.display = 'flex';
    this.element.style.justifyContent = 'center';
    this.element.style.alignItems = 'center';

    const { onClickPlayBtn, onClickStopBtn, t } = props.columnInfo.renderer.options;
    const { rowKey } = props;
    const { playing } = props.grid.store.data.rawData[rowKey];

    const root = createRoot(this.element);
    if (!playing) {
      root.render(
        <button
          type='button'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClickPlayBtn(rowKey);
          }}
        >
          <span className='material-symbols-rounded'>play_arrow</span>
          {/* {t('재생')} */}
        </button>
      );
    } else {
      root.render(
        <button
          type='button'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClickStopBtn(rowKey);
          }}
        >
          <span className='material-symbols-rounded'>pause</span>
          {/* {t('중지')} */}
        </button>
      );
    }
  }

  getElement() {
    return this.element;
  }
  destroy() {
    this.root.unmount();
  }
}
export default CustomAudioPlayBtnRenderer;
